import type { Translations } from "./types.ts";

export const ja: Translations = {
  nav: {
    basketball: "バスケ",
    tennis: "テニス",
    soccer: "サッカー",
    golf: "ゴルフ",
    classic: "Classic",
    ai: "AI",
    comingSoon: "Coming Soon",
    aiTeams: "AI チーム",
  },
  home: {
    heroTitle: "シュートを、進化させよう。",
    heroSubtitle:
      "すべてのシュートを記録・分析・改善。音声操作でハンズフリー、19ゾーンのコート解析、Apple Watch連携。",
    chooseEdge: "あなたに合うプランを選ぼう。",
    classicBadge: "Classic",
    aiBadge: "AI",
    classicTitle: "ShootCreator",
    aiTitle: "ShootCreator AI",
    classicDesc:
      "すべてのバスケ選手のための必須シュートカウンター。音声操作と詳細なゾーン分析で練習を記録。",
    aiDesc:
      "あなた専属のAIシューティングコーチ。リアルタイムのエラー分析、バイオメトリクス、音声メモで練習を革新。",
    classicFeatures: [
      "音声操作でシュートカウント",
      "NBA公式準拠19ゾーン分析",
      "Apple Watch連携",
      "セッション履歴＆タグ管理",
      "完全オフライン・プライバシー重視",
    ],
    aiFeatures: [
      "Classicの全機能に加えて：",
      "AIエラー分類（アーク・深度・左右）",
      "心拍モニタリング＆ゾーン管理",
      "音声メモの文字起こし",
      "バイオメトリクスセッションタイムライン",
    ],
    free: "無料",
    aiPrice: "月額$10",
    learnMore: "詳しく見る",
    courtAnalytics: "コート分析",
    zonesStat: "コートゾーン",
    devicesStat: "デバイス",
    offlineStat: "オフライン",
  },
  classic: {
    heroWordmark: "ShootCreator\nClassic",
    heroSubtitle: "あなた専用のシュートカウンター。",
    voiceTitle: "ハンズフリー。音声操作。",
    voiceDesc:
      "「イン」「アウト」と言うだけでシュートを記録。スマホに触れる必要はありません。ボールに集中できます。",
    voiceListening: "リスニング中...",
    watchTitle: "2デバイス連携。ゼロストレス。",
    watchDesc: "手首からシュートを記録。ゾーン選択、成功・失敗の記録、すべてスマホに触れずに完結。",
    courtTitle: "19ゾーン。完全なピクチャー。",
    courtDesc:
      "制限エリア、ペイント、ミッドレンジ、スリーポイント、ディープレンジをカバーするNBA公式準拠のショットチャート。",
    courtRecentSessions: "最近のセッション",
    courtFgLabel: "FG",
    courtGroupRestricted: "制限エリア",
    courtGroupPaint: "ペイント",
    courtGroupMidRange: "ミッドレンジ",
    courtGroup3pt: "3PT",
    courtGroupDeep: "ディープ",
    sessionTitle: "すべてのセッション。すべてのディテール。",
    sessionDesc: "タグ、ゾーン内訳、フィールドゴール率付きの完全セッション履歴。",
    sessionFgLabel: "フィールドゴール %",
    privacyTitle: "データはあなただけのもの。",
    privacyDesc:
      "すべてのデータはデバイスにローカル保存。アカウント不要、クラウド不要、トラッキングなし。",
    privacyFeatures: [
      { value: "不要", label: "インターネット接続" },
      { value: "ゼロ", label: "クラウドストレージ" },
      { value: "なし", label: "データ共有" },
    ],
    ctaTitle: "無料ではじめよう。",
    ctaButton: "無料ダウンロード",
    ctaNote: "アカウント登録不要。アプリ内課金なし。",
  },
  ai: {
    heroWordmark: "ShootCreator\nAI",
    heroSubtitle: "AIシューティングコーチ。",
    everythingTitle: "Classicの全機能搭載。",
    everythingPlus: "さらに...",
    everythingFeatures: [
      { icon: "🎙️", title: "音声操作", desc: "ハンズフリーでカウント" },
      { icon: "🏀", title: "19ゾーン", desc: "NBA準拠のコート分析" },
      { icon: "⌚", title: "Apple Watch", desc: "手首から記録" },
      { icon: "📊", title: "セッション履歴", desc: "練習ログを完全保存" },
      { icon: "📴", title: "オフライン", desc: "通信不要" },
      { icon: "🔒", title: "プライバシー", desc: "ローカルデータ保存" },
    ],
    errorTitle: "\u30B7\u30E7\u30C3\u30C8\u30A8\u30E9\u30FC\u30E1\u30FC\u30BF\u30FC",
    errorArc: {
      title: "\u30A2\u30FC\u30AF",
      desc: "\u30DF\u30C3\u30C9\u30EC\u30F3\u30B8\u30B8\u30E3\u30F3\u30D1\u30FC\u3067HR160+\u6642\u306B\u30D5\u30E9\u30C3\u30C8\u304C83%\u306B\u6FC0\u5897\u3002\u8DB3\u306E\u75B2\u52B4\u3067\u30EA\u30EA\u30FC\u30B9\u9AD8\u304C\u4F4E\u4E0B\u3002\u30D5\u30A9\u30ED\u30FC\u30B9\u30EB\u30FC\u3068\u30EA\u30B9\u30C8\u30B9\u30CA\u30C3\u30D7\u306E\u7DAD\u6301\u306B\u96C6\u4E2D\u3002",
    },
    errorDepth: {
      title: "\u30C7\u30D7\u30B9",
      desc: "\u30C7\u30A3\u30FC\u30D73PT\u3067HR155+\u6642\u306B\u30B7\u30E7\u30FC\u30C8\u304C41%\u219278%\u306B\u6FC0\u5897\u3002\u4E0B\u534A\u8EAB\u306E\u30D7\u30C3\u30B7\u30E5\u304C\u5F31\u307E\u308B\u2014\u30EC\u30C3\u30B0\u30C9\u30E9\u30A4\u30D6\u3068\u30EA\u30EA\u30FC\u30B9\u30BF\u30A4\u30DF\u30F3\u30B0\u306E\u6539\u5584\u3092\u3002",
    },
    errorDirection: {
      title: "\u65B9\u5411",
      desc: "\u30EC\u30D5\u30C8\u30A6\u30A3\u30F3\u30B03PT\u3067HR170+\u6642\u306B\u5DE6\u30DF\u30B9\u304C72%\u306B\u6FC0\u5897\u3002\u75B2\u52B4\u3067\u8170\u56DE\u8EE2\u304C\u5D29\u308C\u308B\u2014\u30E9\u30C6\u30E9\u30EB\u30D0\u30E9\u30F3\u30B9\u30C9\u30EA\u30EB\u3092\u3002",
    },
    heartTitle: "心拍が語るストーリー。",
    heartDesc: "セッション中の心拍ゾーンを追跡。疲労がシュート精度に与える影響を可視化。",
    heartBpm: "BPM",
    voiceTitle: "すべての言葉。すべての洞察。",
    voiceStatusRecording: "セッション録音中",
    voiceStatusAnalyzing: "分析中...",
    voiceStatusReport: "セッションレポート",
    voiceSessionLines: [
      {
        speaker: "あなた",
        text: "コーナースリー、成功。",
        tags: [
          { label: "3PT", type: "zone" },
          { label: "成功", type: "result" },
        ],
      },
      {
        speaker: "あなた",
        text: "エルボージャンパー、ショートミス。",
        tags: [
          { label: "ミッド", type: "zone" },
          { label: "ミス", type: "result" },
          { label: "ショート", type: "error" },
        ],
      },
      {
        speaker: "あなた",
        text: "脚が重い。リリースがフラットだった。",
        tags: [{ label: "フラットアーク", type: "error" }],
      },
      {
        speaker: "あなた",
        text: "フリースロー、スウィッシュ。",
        tags: [
          { label: "ペイント", type: "zone" },
          { label: "成功", type: "result" },
        ],
      },
    ],
    voiceReportIntro:
      "心拍影響を起点に、弱点帯・ショット傾向を分析しました。以下のドリルメニューを提案します。",
    voiceInsightCards: [
      {
        icon: "\uD83D\uDD0D",
        title: "\u5FC3\u62CD\u5F71\u97FF \u00D7 \u30BE\u30FC\u30F3\u5206\u6790",
        value:
          "\u30DF\u30C3\u30C9\u30B8\u30E3\u30F3\u30D1\u30FC\u306EFG%\u304CHR155+\u306738%\u219222%\u306B\u4F4E\u4E0B\u3002\u30A8\u30EB\u30DC\u30FC\u304B\u3089\u306E\u30D7\u30EB\u30A2\u30C3\u30D7\u3067\u9855\u8457\u3002",
        change: "-16%",
        changeType: "negative",
        chartType: "zoneFg",
      },
      {
        icon: "\uD83C\uDFAF",
        title: "AI\u30C9\u30EA\u30EB\u30D7\u30E9\u30F3",
        value:
          "HR155+\u306E\u5F31\u70B9\u30BE\u30FC\u30F3\u3092\u72D9\u3063\u305F5\u3064\u306E\u30C9\u30EA\u30EB\u3002",
        change: "+15%",
        changeType: "positive",
        chartType: "drillPlan",
      },
      {
        icon: "\uD83D\uDCCA",
        title: "3D\u30A8\u30E9\u30FC\u30E1\u30FC\u30BF\u30FC",
        value:
          "\u30B7\u30E7\u30FC\u30C8/\u30ED\u30F3\u30B0/\u30D5\u30E9\u30C3\u30C8/\u5DE6/\u53F3\u306E\u6FC0\u5897\u30DD\u30A4\u30F3\u30C8\u3092HR\u5E2F\u5225\u306B\u7279\u5B9A\u3002",
        change: "62%",
        changeType: "negative",
        chartType: "arcPattern",
      },
    ],
    voiceDrillSteps: [
      {
        id: "zone-green",
        time: "HR < 140",
        label: "ミドルレンジ キャッチ&シュート ×20本",
        detail: "最適HR帯で筋肉記憶を構築。FG% 65%+",
        color: "#34c759",
        context: "ベースライン：疲労前にフォームを確立",
      },
      {
        id: "zone-yellow",
        time: "HR 140-155",
        label: "3PTスポットアップ ×15本（セット間30秒レスト）",
        detail: "FG%低下開始帯。アーク一貫性とフォロースルーに集中",
        color: "#ffcc00",
        context: "アーク傾向：フラットアークが出始める帯域。高いリリースを意識",
      },
      {
        id: "zone-orange",
        time: "HR 155-165",
        label: "左エルボー プルアップジャンパー ×12本",
        detail: "疲労下での弱点ポイント。FG34% → 目標45%+",
        color: "#ff9f0a",
        context: "← ミッドジャンパーの弱点帯。アーチを意識",
      },
      {
        id: "zone-red",
        time: "HR 165-180",
        label: "スプリント → キャッチ&シュート ×8本（実戦速度）",
        detail: "クラッチ状況シミュ。FG%が23%低下する帯域 — 耐性強化",
        color: "#ff3b30",
        context: "← Zone5でのFG%低下を耐性強化で改善",
      },
      {
        id: "cooldown",
        time: "HR < 130",
        label: "フリースロー ルーティン ×15本（クールダウン）",
        detail: "乳酸を流してリズムを回復。HR140未満でFG%が+18%回復",
        color: "#34c759",
        context: "リカバリー：高HR帯ドリル後のリズム回復",
      },
    ],
    transcriptLines: [
      { speaker: "あなた", text: "左エルボーからのミドルレンジ、リリースの感触良かった。" },
      { speaker: "AI", text: "記録：成功。本日のミドルレンジFG% 62% — 平均より8%上です。" },
      { speaker: "あなた", text: "今のはショート。脚が重くなってきた。" },
      {
        speaker: "AI",
        text: "ショートミスとしてタグ付け。心拍165 BPM — 直近5分のFG%が12%低下。",
      },
      { speaker: "あなた", text: "休憩すべき？" },
      {
        speaker: "AI",
        text: "3分の休憩を推奨。過去のセッションではクールダウン後に精度が15%回復しています。",
      },
    ],
    dashboardTitle: "完全なピクチャー。",
    dashboardDesc: "シュート、心拍、音声メモ — すべてを一つのタイムラインで。",
    modelTitle: "あなたのAI。あなたの選択。",
    modelSubtitle: "あらゆるLLMで、リアルデータの力を解放する。",
    modelTagline:
      "web \u00B7 mobile \u00B7 watch \u2014 信頼するAIが駆動する、最高のスポーツ改善体験。",
    modelYourModel: "あなたのモデル",
    modelLocalLlm: "ローカルLLM",
    modelAnyCompatible: "OpenAI互換すべて対応",
    planByok: "BYOK",
    planSubscribe: "サブスクリプション",
    planFreePrice: "無料",
    planFreeNote: "自分のAPIキーを使用",
    planFreeFeatures: [
      "すべてのAI分析機能",
      "任意のLLMプロバイダーを選択",
      "ローカルモデル対応（Qwen, Ollama）",
      "完全なデータ管理",
      "コミュニティサポート",
    ],
    planFreeCta: "始める",
    planSubPrice: "$10",
    planSubNote: "/月",
    planSubFeatures: [
      "すべてのAI分析機能",
      "APIキーの設定不要",
      "常に最適化されたモデル",
      "自動アップデート",
      "優先サポート",
    ],
    planSubCta: "無料トライアルを開始",
    analyticsTitle: "データ駆動の改善。",
    analyticsSubtitle:
      "心拍数、シュート精度、ゾーン分析 — リアルタイムで相関を可視化し、最も重要なことを明らかに。",
    analyticsTimelineLabel: "心拍 + シュートタイムライン",
    analyticsBpmThreshold: "160 BPM",
    analyticsZoneTitle: "ゾーン別FG%内訳",
    analyticsZoneGroups: [
      "ゾーン1-2（ペイント）",
      "ゾーン3（ミッド）",
      "ゾーン4（3PT）",
      "ゾーン5（ディープ）",
    ],
    analyticsMonthlyTitle: "3ヶ月の推移",
    analyticsMonths: ["1月", "2月", "3月"],
    analyticsSessions: "セッション",
    analyticsMonthlyInsight: "45セッションのAIガイド付きフォーカスドリルでゾーン3のFGが16%改善。",
    analyticsInsights: [
      "心拍160 BPMを超えるとFG%が23%低下。3分の休憩を推奨。",
      "ミッドレンジ集中ドリルで3ヶ月間にゾーン3の精度が16%向上。",
      "10分のウォームアップ後、左エルボーからのシュートが8%改善。",
      "3月のセッションでは最初の20分が最も精度が高い。",
    ],
    dashboardShots: "シュート",
    dashboardShotsUnit: "本",
    dashboardSessionDuration: "60分セッション",
    dashboardHeartRate: "心拍数",
    dashboardVoiceMemos: "ボイスメモ",
    dashboardVoiceLines: [
      "「コーナースリー、成功」",
      "「エルボー、ショートミス」",
      "「フリースロー、スウィッシュ」",
      "「ウイングスリー、左ミス」",
      "「トップオブキー、成功」",
      "「右ウイング、ショート」",
      "「エルボージャンパー、フラット」",
      "「ペイントフィニッシュ、アンドワン」",
    ],
    dashboardInsights: [
      { label: "左右", value: "500本中275本が左右均等 — 一致度55%" },
      { label: "角度", value: "500本中200本が適正角度 — 一致度40%" },
      { label: "深さ", value: "500本中220本が深度正確 — 一致度44%" },
      { label: "心拍ゾーン影響", value: "500本のHRゾーン別FG%内訳" },
      { label: "エリア別パフォーマンス", value: "500本のエリア別FG%と平均心拍" },
    ],
    gaugeLabels: {
      direction: { left: "左", right: "右" },
      arc: { left: "フラット", right: "ハイ" },
      depth: { left: "ショート", right: "オーバー" },
    },
    progressionTitle: "セッションの積み上げ。",
    progressionDesc: "1回のセッションが1ヶ月に、3ヶ月に、6ヶ月に — 改善は否定できないものになる。",
    progressionSessions: "セッション",
    progressionShots: "本",
    progressionFg: "FG%",
    progressionImprovement: "改善",
    progressionPeriods: [
      { label: "1ヶ月", sessions: 12, shots: "6,000", fg: 54, dir: 55, arc: 40, depth: 44 },
      { label: "3ヶ月", sessions: 38, shots: "19,000", fg: 58, dir: 61, arc: 48, depth: 52 },
      { label: "6ヶ月", sessions: 82, shots: "41,000", fg: 63, dir: 68, arc: 57, depth: 61 },
    ],
    ctaTitle: "無料トライアルを始めよう。",
    ctaSubtitle: "トライアル後、月額$10。",
    ctaButton: "始める",
    ctaNote: "いつでもキャンセル可能。契約の縛りなし。",
    // HR Zone Matrix
    hrZoneTitle: "心拍帯\u00D7ゾーン分析",
    hrZoneDesc: "心拍帯とコートエリア別のFG%",
    hrZoneWeakness: "弱点",
    hrZoneWeapon: "武器",
    hrZoneWeaknessDesc:
      "ミッドジャンパーのFG%がZone 4-5で68%低下。疲労下でフラットアークの傾向。高心拍帯でのフォーム維持ドリルを推奨。",
    hrZoneWeaponDesc: "ペイントのFG%はHR175+でも72%を維持。圧倒的武器として磨き続けることを推奨。",
    hrZoneZones: ["ペイント", "ミッド", "3PT", "ディープ"],
    hrZoneHrBands: ["Z1 <130", "Z2 130-145", "Z3 145-160", "Z4 160-175", "Z5 175+"],
    hrZoneSuggestTitle: "AIドリル提案",
    hrZoneBenchmarkYou: "あなたのスタッツ",
    hrZoneBenchmarkRec: "vs 社会人一般",
    hrZoneBenchmarkNba: "vs NBAプロ平均",
    hrZoneBenchmarkNcaa: "vs 全米大学Top100",
    hrZoneBenchmarkCurry: "vs ステフィン・カリー",
    hrZoneBenchmarkSimmons: "vs ベン・シモンズ",
    hrZoneHeadline: "ギャップを、知れ。埋めろ。",
    hrZoneHeadlineDesc:
      "心拍帯×ゾーン別のシューティング指紋を、週末プレーヤーからNBA史上最高のシューターまで、あらゆる基準と比較せよ。",
  },
  comingSoon: {
    badge: "近日公開",
    inDevelopment: "開発中",
    backToBasketball: "← バスケに戻る",
  },
  tennis: {
    title: "テニス",
    subtitle:
      "個人技のストロークを磨き込むカウンティングロガー。サーブスピード計測、ショットタイプ別（フォア・バック・ボレー）のラリーカウント、コートゾーン配置を記録。",
    classicTitle: "ストロークカウンター",
    classicDesc:
      "音声操作でショットタイプ別ラリーカウント、サーブスピード記録、コートゾーン配置ヒートマップ、セッション履歴。オフライン優先＆プライバシー重視。",
    aiTitle: "AIストロークコーチ",
    aiDesc:
      "AIストローク分類＆フォーム分析、練習中の心拍モニタリング、技術メモの音声文字起こし、バイオメトリクス分析。",
    heroWordmark: "サーブを、可視化する。",
    heroSubtitle:
      "音声操作でストロークカウント、T/Body/Wideサーブ配置分析、セッション履歴 — すべて手首から。",
    voiceTitle: "すべてのラリーを記録。",
    voiceDesc:
      "ショットタイプを声で — フォア、バック、ボレー — ShootCreatorが瞬時に記録。練習中にスマホを持つ必要なし。",
    analyticsTitle: "コートゾーンヒートマップ",
    analyticsDesc:
      "サーブの着弾点を可視化。T、Body、Wide — デュースサイドとアドサイドのゾーン精度をHawk-Eyeグレードの分析で追跡。",
    features: [
      {
        icon: "\u{1F3BE}",
        title: "サーブゾーン",
        desc: "T / Body / Wide をサービスボックス別に追跡",
      },
      {
        icon: "\u{1F399}\u{FE0F}",
        title: "音声カウント",
        desc: "ハンズフリーでショットタイプを記録",
      },
      { icon: "\u{231A}", title: "Apple Watch", desc: "ラリー中に手首からカウント" },
      { icon: "\u{1F4CA}", title: "セッション履歴", desc: "FH/BH/ボレーの比率推移を確認" },
      {
        icon: "\u{1F512}",
        title: "オフライン優先",
        desc: "アカウント不要、クラウド不要、広告なし",
      },
      { icon: "\u{1F30D}", title: "ラリー深度", desc: "Deep / Mid / Short の着弾ゾーン" },
    ],
    ctaTitle: "無料で始めよう。",
    ctaButton: "App Storeでダウンロード",
    ctaNote: "無料。アカウント不要。",
  },
  soccer: {
    title: "サッカー",
    subtitle:
      "個人技のシュートを磨き込むシューティング練習ロガー。パワーショット、コントロールショット、フリーキックを記録し、ゴールゾーンヒートマップで配置を可視化。",
    classicTitle: "シュートロガー",
    classicDesc:
      "音声操作でパワーショット・コントロールショット・フリーキックをカウント。ゴールゾーンヒートマップ、セッション履歴。どんなフィールドでもオフラインで動作。",
    aiTitle: "AIシュートコーチ",
    aiDesc:
      "AIシュート品質分析（パワー＆配置スコアリング）、ドリル中の心拍追跡、音声メモの文字起こし、ゴールゾーンバイオメトリクスダッシュボード。",
    heroWordmark: "すべてのシュートを、記録する。",
    heroSubtitle: "音声操作のシューティング練習ロガー。6ゾーンゴール分析、PK追跡、セッション履歴。",
    voiceTitle: "ハンズフリーでシュート記録。",
    voiceDesc:
      "ショットタイプ — パワー、コントロール、フリーキック — とゾーンを声で。テクニックに集中しながらShootCreatorが記録。",
    analyticsTitle: "6ゾーンゴール分析",
    analyticsDesc:
      "ゾーン別のコンバージョン率を可視化 — 上隅 vs 下中央。StatsBomb/Optaと同じ2×3ゾーンモデル。",
    features: [
      { icon: "\u{26BD}", title: "6ゾーンゴール", desc: "上/下 × 左/中/右のコンバージョン追跡" },
      {
        icon: "\u{1F399}\u{FE0F}",
        title: "音声カウント",
        desc: "ハンズフリーでショットタイプ記録",
      },
      { icon: "\u{231A}", title: "Apple Watch", desc: "ピッチからクイック記録" },
      { icon: "\u{1F3AF}", title: "PK追跡", desc: "専用ペナルティキック分析" },
      { icon: "\u{1F512}", title: "オフライン優先", desc: "Wi-Fi不要、どんなフィールドでも動作" },
      { icon: "\u{1F4CA}", title: "セッション履歴", desc: "週単位の改善を追跡" },
    ],
    ctaTitle: "無料で始めよう。",
    ctaButton: "App Storeでダウンロード",
    ctaNote: "無料。アカウント不要。",
  },
  golf: {
    title: "ゴルフ",
    subtitle:
      "アプローチショットとパッティングの練習ロガー。距離コントロール、グリーン周りの精度、パット成功率をビジュアルグリーンマップで追跡。",
    classicTitle: "ショートゲームロガー",
    classicDesc:
      "音声操作で距離帯別アプローチ＆パットカウント、グリーン周り精度ヒートマップ、セッション履歴。オフライン優先、アカウント不要。",
    aiTitle: "AIショートゲームコーチ",
    aiDesc:
      "AIアプローチ品質分析（距離＆ラインスコアリング）、プレッシャーパット時の心拍追跡、音声メモの文字起こし、グリーン周りバイオメトリクスダッシュボード。",
    heroWordmark: "ウェッジを、磨き込む。",
    heroSubtitle:
      "音声操作のアプローチ＆パットロガー。Strokes Gained距離バンド、パッティング距離リング、セッション分析。",
    voiceTitle: "目を離さずに記録。",
    voiceDesc:
      "距離と結果を声で — 「75ヤード、オングリーン」— リズムを崩さず記録。ショット間にスマホ操作不要。",
    analyticsTitle: "Strokes Gainedゾーン",
    analyticsDesc:
      "距離帯別のGIR%と期待ストロークを追跡 — 50ヤード以内から200ヤード+まで。パッティングリングで3ft/10ft/20ft/30ftのメイク率を表示。",
    features: [
      { icon: "\u{26F3}", title: "距離バンド", desc: "<50y / 50-100y / 100-150y / 150-200y" },
      { icon: "\u{1F399}\u{FE0F}", title: "音声ロギング", desc: "距離と結果をハンズフリーで記録" },
      { icon: "\u{231A}", title: "Apple Watch", desc: "グリーン上からパット記録" },
      {
        icon: "\u{1F4CF}",
        title: "パッティングリング",
        desc: "3ft / 10ft / 20ft / 30ft のメイク率",
      },
      { icon: "\u{1F512}", title: "オフライン優先", desc: "アカウント不要、どこでも動作" },
      { icon: "\u{1F4CA}", title: "Strokes Gained", desc: "PGAツアー基準との比較" },
    ],
    ctaTitle: "無料で始めよう。",
    ctaButton: "App Storeでダウンロード",
    ctaNote: "無料。アカウント不要。",
  },
  aiTeam: {
    heroTitle: "一人の練習を、チームの力に。",
    heroSubtitle:
      "選手の練習データをリアルタイムで共有。コーチの目が届かない自主練も、数字がすべてを語ります。",
    heroCta: "無料でチームを作る",
    heroDemo: "デモを見る",
    painTitle: "こんな悩み、ありませんか？",
    painCards: [
      {
        icon: "\u{1F3C0}",
        role: "コーチ",
        pain: "「30人の練習、全部は見られない」",
      },
      {
        icon: "\u{1F4AA}",
        role: "選手",
        pain: "「自主練の成果を誰にも見てもらえない」",
      },
      {
        icon: "\u{1F3EB}",
        role: "アカデミー",
        pain: "「複数拠点のデータが統一できない」",
      },
    ],
    painSolution: "ShootCreator AI Teams なら、すべて解決。",
    // Roster
    rosterTitle: "15人ロスターを一目で管理",
    rosterSubtitle: "全選手のスタッツ、心拍数、負荷状態を統一ロスタービューで。",
    rosterLegendOnCourt: "オンコート",
    rosterLegendBench: "ベンチ",
    rosterOnCourtBadge: "出場中",
    rosterLoadReady: "万全",
    rosterLoadMonitor: "注意",
    rosterLoadFatigued: "疲労",
    rosterPlayers: [
      {
        number: 0,
        name: "S. フォンテッキオ",
        pos: "SF",
        height: "201cm",
        hrAvg: 136,
        loadStatus: "green",
      },
      {
        number: 2,
        name: "T. ロジアー",
        pos: "PG",
        height: "185cm",
        hrAvg: 152,
        loadStatus: "yellow",
      },
      {
        number: 5,
        name: "N. ヨビッチ",
        pos: "PF",
        height: "208cm",
        hrAvg: 138,
        loadStatus: "green",
      },
      {
        number: 7,
        name: "K. ウェア",
        pos: "C",
        height: "213cm",
        hrAvg: 144,
        loadStatus: "green",
      },
      {
        number: 9,
        name: "P. ラーション",
        pos: "SG",
        height: "196cm",
        hrAvg: 140,
        loadStatus: "green",
      },
      {
        number: 11,
        name: "J. ハケス Jr.",
        pos: "SF",
        height: "198cm",
        hrAvg: 150,
        loadStatus: "green",
      },
      {
        number: 12,
        name: "D. スミス",
        pos: "PG",
        height: "188cm",
        hrAvg: 134,
        loadStatus: "green",
      },
      {
        number: 13,
        name: "B. アデバヨ",
        pos: "C",
        height: "206cm",
        hrAvg: 158,
        loadStatus: "yellow",
      },
      {
        number: 14,
        name: "T. ヒーロー",
        pos: "SG",
        height: "196cm",
        hrAvg: 148,
        loadStatus: "green",
      },
      {
        number: 16,
        name: "K. ジョンソン",
        pos: "SF",
        height: "198cm",
        hrAvg: 142,
        loadStatus: "green",
      },
      {
        number: 22,
        name: "A. ウィギンズ",
        pos: "SF",
        height: "201cm",
        hrAvg: 146,
        loadStatus: "green",
      },
      {
        number: 24,
        name: "N. パウエル",
        pos: "SG",
        height: "193cm",
        hrAvg: 145,
        loadStatus: "green",
      },
      {
        number: 25,
        name: "K. ヤクチョニス",
        pos: "PG",
        height: "196cm",
        hrAvg: 139,
        loadStatus: "green",
      },
      {
        number: 45,
        name: "D. ミッチェル",
        pos: "PG",
        height: "183cm",
        hrAvg: 143,
        loadStatus: "yellow",
      },
      {
        number: 50,
        name: "V. ゴルディン",
        pos: "C",
        height: "213cm",
        hrAvg: 130,
        loadStatus: "green",
      },
      {
        number: 99,
        name: "E. スポエルストラ",
        pos: "HC",
        height: "188cm",
        hrAvg: 205,
        loadStatus: "red",
      },
    ],
    // Realtime Heart Rate
    realtimeTitle: "リアルタイム心拍モニタリング",
    realtimeDesc:
      "オンコート全選手のライブBPM、HRゾーン、ECG波形をPolarセンサー経由でリアルタイム表示。",
    realtimeBleConnected: "接続済み",
    realtimeBleReconnecting: "再接続中",
    realtimeBleLost: "切断",
    // Polar BLE
    polarTitle: "Polar BLE連携",
    polarDesc: "ベンチ近接自動同期＆瞬時再接続。",
    polarFeatures: [
      "BLEベンチ近接自動接続",
      "信号ロス時の自動再接続",
      "最大15台マルチセンサー並列ペアリング",
      "1Hzリアルタイムデータストリーミング",
    ],
    // Load Management
    loadTitle: "セッション別ロードマネジメント",
    loadDesc: "HRVベースの疲労追跡 — 誰が万全で、誰に休息が必要かを把握。",
    loadMetrics: ["HRV（心拍変動）", "TRIMP（トレーニングインパルス）", "RPE（自覚的運動強度）"],
    loadPlayersLabel: "選手一覧",
    loadWeeklyLoadLabel: "週間負荷",
    loadHrvTrendLabel: "HRV推移（7日間）",
    loadTrimpTrendLabel: "TRIMP推移（5週間）",
    loadTrainingSessionsLabel: "トレーニングセッション",
    loadLevelLow: "低",
    loadLevelMed: "中",
    loadLevelHigh: "高",
    loadLevelOver: "過負荷",
    loadLevelRest: "休養",
    loadDays: ["月", "火", "水", "木", "金", "土", "日"],
    loadStatusElevated: "やや上昇",
    loadStatusOptimal: "最適",
    loadStatusFresh: "万全",
    loadStatusRecovery: "回復中",
    loadStatusOverreaching: "オーバーリーチ",
    loadStatusInjured: "負傷中",
    loadSessionTypes: {
      scrimmage5v5: "5対5スクリメージ",
      shootingDrills: "シューティングドリル",
      gameVsLal: "試合 vs LAL",
      lightShoot: "軽めのシュート練習",
      gameVsBkn: "試合 vs BKN",
      conditioning: "コンディショニング",
      gameVsMia: "試合 vs MIA",
      recoveryRun: "リカバリーラン",
      teamPractice: "チーム練習",
      gameVsChi: "試合 vs CHI",
      shooting: "シュート練習",
      filmLight: "フィルム＋軽練習",
      practice: "練習",
      rehabWalk: "リハビリウォーク",
      lightShooting: "軽めのシュート",
      skillsTraining: "スキルトレーニング",
      individualWork: "個人練習",
      recovery: "リカバリー",
      gameVsPhi: "試合 vs PHI",
      gameVsAtl: "試合 vs ATL",
      lightPractice: "軽めの練習",
      poolRehab: "プールリハビリ",
      gameVsBos: "試合 vs BOS",
      gameVsNyk: "試合 vs NYK",
    },
    // Live Game View
    gameTitle: "ライブゲームビュー",
    gameDesc: "ライブ心拍、ゲームスタッツ、ベンチ交代管理をコート上でリアルタイム可視化。",
    gameLiveScore: "ライブスコア",
    gameScoreValue: "68 – 61",
    gameBenchLabel: "ベンチ",
    // Team Calendar
    calendarTitle: "チームカレンダー",
    calendarDesc: "試合、練習、回復日を一元管理。週間チーム負荷サマリーも一目瞭然。",
    calendarDayHeaders: ["日", "月", "火", "水", "木", "金", "土"],
    calendarLegendGame: "試合",
    calendarLegendPractice: "練習",
    calendarLegendRecovery: "回復",
    calendarLegendRest: "休養",
    calendarMonthTitle: "2026年3月",
    calendarWeekLoadLabel: "週間負荷",
    calendarOpponents: {
      4: "vs LAL",
      7: "vs BKN",
      11: "vs BOS",
      18: "vs CHI",
      21: "vs PHI",
      25: "vs ATL",
    },
    calendarToughWeekLabel: "ハードウィーク",
    calendarLoadSummary: {
      low: "低負荷",
      moderate: "中負荷",
      high: "高負荷",
      extreme: "過負荷",
    },
    // Rest Suggestion
    restTitle: "AI休養サジェスト",
    restDesc: "累積負荷、HRV推移、今後のスケジュール密度に基づくプロアクティブなリカバリー提案。",
    restAlertBadge: "ALERT",
    restWarningBadge: "WARNING",
    restInsightBadge: "INSIGHT",
    restSuggestions: [
      {
        type: "alert",
        player: "B. アデバヨ",
        text: "TRIMP閾値を3日連続超過。休養日を強く推奨。",
      },
      {
        type: "alert",
        player: "N. パウエル",
        text: "ACWRが1.18（危険域）。即座の負荷軽減が必要。",
      },
      {
        type: "warning",
        player: "T. ロジアー",
        text: "HRV低下傾向を検出。負荷を注意深くモニタリング。",
      },
      {
        type: "warning",
        player: "E. スポエルストラ",
        text: "5日連続オーバーロード。強制リカバリーセッションの設定を。",
      },
      {
        type: "insight",
        player: "チーム",
        text: "チーム3PT%が今週4.2%向上。ペリメーターセットの増加を検討。",
      },
      {
        type: "insight",
        player: "T. ヒーロー",
        text: "ACWRが1.03で最適値。出場時間増加の好候補。",
      },
    ],
    restAiLabel: "AI推奨",
    // Management Dashboard
    managementTitle: "マネジメントダッシュボード",
    managementDesc: "4パネル統合ビュー — コーチングスタッフに必要なすべてを。",
    managementPanels: [
      { icon: "\u{1F4C8}", title: "FG%トレンド", desc: "チームシュート精度の推移" },
      { icon: "\u{1F6A6}", title: "ロードステータス", desc: "選手別コンディション一覧" },
      { icon: "\u{1F4C5}", title: "週間スケジュール", desc: "今週の試合と練習予定" },
      { icon: "\u{1F9E0}", title: "AIインサイト", desc: "疲労警告とパフォーマンス提案" },
    ],
    managementLoadReady: "万全",
    managementLoadMonitor: "注意",
    managementLoadRest: "休養",
    managementSchedule: [
      { icon: "\u{1F4AA}", text: "チーム練習", day: "月 9:00" },
      { icon: "\u{1F3C0}", text: "vs レイカーズ", day: "火 19:00" },
      { icon: "\u{1F504}", text: "リカバリーセッション", day: "水 10:00" },
      { icon: "\u{1F4AA}", text: "シューティングドリル", day: "木 9:00" },
      { icon: "\u{1F3C0}", text: "vs ネッツ", day: "金 19:30" },
    ],
    managementInsights: [
      {
        type: "warning",
        text: "アデバヨのTRIMPが3日連続で閾値を超過。休養日を推奨。",
      },
      {
        type: "suggestion",
        text: "チーム3PT%が今週4.2%改善。ペリメーターセットの増加を検討。",
      },
      { type: "warning", text: "ロジアーのHRVが低下傾向。ワークロードを注視。" },
    ],
    managementGaugeLabel: "チームFG%",
    managementGaugeLeft: "低",
    managementGaugeRight: "高",
    dashboardTitle: "30人の成長、ひとつの画面に。",
    dashboardSubtitle: "全選手の成長曲線、練習頻度、ゾーン精度を一目で把握。",
    modelsTitle: "3つの共有モデル",
    models: [
      {
        id: "personal",
        icon: "\u{1F91D}",
        title: "個人共有",
        desc: "信頼できるコーチやメンターにデータを共有。共有範囲は自分でコントロール。",
      },
      {
        id: "team",
        icon: "\u{1F465}",
        title: "チームモード",
        desc: "部活、クラブ、アカデミーを丸ごと管理。コーチは全選手を一覧で確認。",
      },
      {
        id: "community",
        icon: "\u{1F310}",
        title: "コミュニティ",
        desc: "スキルコーチが自分のコミュニティを運営。ドリル配布、進捗追跡、ブランド構築。",
      },
    ],
    featuresTitle: "コーチと選手のために",
    features: [
      {
        icon: "\u{1F4CA}",
        title: "チームダッシュボード",
        desc: "FG%推移、練習ヒートマップ、ゾーン分析を一画面で。",
      },
      {
        icon: "\u{1F4F1}",
        title: "スマート招待",
        desc: "QRコードまたはリンク。ワンスキャンでチーム参加。",
      },
      {
        icon: "\u{1F4AC}",
        title: "コーチフィードバック",
        desc: "セッションにコメント。AIが下書きをアシスト。",
      },
      {
        icon: "\u{1F3C6}",
        title: "リーダーボード",
        desc: "健全な競争が成長を加速。ゾーン別精度ランキング。",
      },
      {
        icon: "\u{1F4CB}",
        title: "練習プラン",
        desc: "メニューを配って、実施状況を自動追跡。",
      },
      {
        icon: "\u{1F512}",
        title: "ロール管理",
        desc: "オーナー、コーチ、選手、閲覧者。必要な人に必要な情報だけ。",
      },
    ],
    pricingTitle: "チーム規模に合わせたプラン",
    plans: [
      {
        name: "Free",
        price: "¥0",
        note: "永久無料",
        members: "5名まで",
        features: ["1チーム", "基本ダッシュボード", "リーダーボード"],
        cta: "無料で始める",
      },
      {
        name: "Pro",
        price: "¥4,980",
        note: "/月",
        members: "25名まで",
        features: [
          "3チーム",
          "フルダッシュボード",
          "コーチフィードバック",
          "練習プラン",
          "全リーダーボード",
        ],
        cta: "30日間無料トライアル",
        recommended: true,
      },
      {
        name: "Enterprise",
        price: "¥19,800",
        note: "/月",
        members: "無制限",
        features: [
          "無制限チーム",
          "カスタムブランディング",
          "APIアクセス",
          "AIインサイト",
          "優先サポート",
        ],
        cta: "お問い合わせ",
      },
    ],
    ctaTitle: "チームの可能性を、データで解き放とう。",
    ctaSubtitle: "Proプラン 30日間無料トライアル。クレジットカード不要。",
    ctaButton: "チームを作る",
  },
  footer: {
    basketballClassic: "バスケ Classic",
    basketballAi: "バスケ AI",
    tennis: "テニス",
    soccer: "サッカー",
    golf: "ゴルフ",
    github: "GitHub",
    copyright: `© ${new Date().getFullYear()} ShootCreator. All rights reserved.`,
  },
  common: {
    scroll: "スクロール",
  },
};
